var _defs, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 141.73 141.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{opacity:0.39;fill:url(#linear-gradient-4);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 27.98,
    y1: 70.87,
    x2: 113.75,
    y2: 70.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#47bdc6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00737c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 32.09,
    y1: 97.65,
    x2: 104.51,
    y2: 60.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a0ddea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6bcbd2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 54.83,
    y1: 54.25,
    x2: 83.18,
    y2: 83.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 30.32,
    y1: 89.63,
    x2: 89.81,
    y2: 89.63,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 4 copy 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.14,39.36a15.32,15.32,0,0,0-26.55,0L30.06,87a15.33,15.33,0,0,0,13.27,23H98.4a15.34,15.34,0,0,0,13.28-23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.51,40.86,33.32,89.68a10.81,10.81,0,0,0,9.36,16.22H99.05a10.81,10.81,0,0,0,9.36-16.22L80.23,40.86A10.81,10.81,0,0,0,61.51,40.86Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73.15,80.56H68.58A1.55,1.55,0,0,1,67,79.1L65.2,50.18a1.55,1.55,0,0,1,1.55-1.66H75a1.57,1.57,0,0,1,1.56,1.66L74.71,79.1A1.55,1.55,0,0,1,73.15,80.56Zm-2.28,5.09A5.31,5.31,0,1,0,76.17,91,5.31,5.31,0,0,0,70.87,85.65Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M42.74,73.37h0L31.5,92.83A8.71,8.71,0,0,0,39,105.9H89.81L62.9,100.66A25.09,25.09,0,0,1,42.74,73.37Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.8db63a357f3f318e5e9b6f5cd835a5bc.svg";
export { ForwardRef as ReactComponent };